/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { NodeDependencies } from './dependenciesNode.generated.js';
import { createObjectNode } from '../../factoriesAny.js';
export var ObjectNodeDependencies = {
  NodeDependencies,
  createObjectNode
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesObjectNode.generated.js
// module id = 187
// module chunks = 2